import React from "react";

function ReportsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      {...props}
    >
      <g id="Reports" transform="translate(0.5 -0.406)">
        <rect
          id="Rectangle_93"
          data-name="Rectangle 93"
          width="40"
          height="40"
          transform="translate(0 0.406)"
          fill="none"
        />
        <path
          id="Path_454"
          data-name="Path 454"
          d="M276,281.819c.075,0,.075-.1.092-.158a1.81,1.81,0,0,1,1.826-1.251h12.108a.542.542,0,0,1,.509.258c.976,1.384,1.968,2.752,2.935,4.169a.625.625,0,0,0,.575.292h15.843a2.135,2.135,0,0,1,1.234.275,1.868,1.868,0,0,1,.876,1.668v3.669c0,.317.092.384.392.375h1.793a1.668,1.668,0,0,1,1.743,1.409c0,.058,0,.108.075.117v.709c-.125.058-.117.192-.15.292l-6.579,18.028a1.8,1.8,0,0,1-2.093,1.451h-29.11a4.333,4.333,0,0,1-.467,0,1.718,1.718,0,0,1-1.426-.959c-.05-.1,0-.233-.167-.284Zm16.677,29.935h14.651a.584.584,0,0,0,.667-.434q3.335-9.064,6.621-18.136c.183-.509,0-.767-.55-.767h-29.31a.642.642,0,0,0-.709.5q-2.41,6.671-4.845,13.342l-1.776,4.861c-.167.459,0,.65.467.659h14.784Zm-15.318-4.611h.058c.05-.142.108-.275.167-.417l5.237-14.292a2.412,2.412,0,0,1,.334-.692,1.943,1.943,0,0,1,1.668-.684h25.449c.35,0,.434-.092.425-.434V287.23c0-.725-.117-.834-.834-.834h-16.41a.742.742,0,0,1-.7-.35c-.951-1.351-1.918-2.685-2.868-4.036a.609.609,0,0,0-.542-.275H278.185c-.734,0-.834.108-.834.834v24.565Z"
          transform="translate(-276 -276)"
          fill="#fff"
          stroke="currentColor"
          stroke-width="1"
        />
      </g>
    </svg>
  );
}

export default ReportsIcon;
